"use client";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useEvaluationRuntime } from "./evaluation-runtime";

export function EvaluationOperationNotices() {
  const runtime = useEvaluationRuntime(),
    t = useTranslations("evaluation");
  if (
    !runtime.ready ||
    (runtime.available && !runtime.records.length && !runtime.terminal)
  )
    return null;
  return (
    <aside
      data-slot="evaluation-operation-notices"
      data-debug-source="src/components/evaluation/evaluation-operation-notices.tsx"
      className="m-4 space-y-3 rounded-lg border border-warning-border bg-warning-soft p-4 text-sm text-warning-foreground sm:mx-6"
      aria-live="polite"
    >
      {!runtime.available ? (
        <div className="space-y-2">
          <p>{t("storageBlocked")}</p>
          <Button variant="outline" onClick={runtime.restore}>
            {t("checkStorage")}
          </Button>
        </div>
      ) : null}
      {runtime.records.map((record) => (
        <div key={record.idempotencyKey} className="space-y-2">
          <p>{t("unknownOperation")}</p>
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              disabled={runtime.pending}
              onClick={() => void runtime.lookup(record)}
            >
              {t("checkResult")}
            </Button>
            <Button variant="ghost" asChild>
              <Link href={`/sourcing/${record.eventId}`}>{t("viewEvent")}</Link>
            </Button>
          </div>
        </div>
      ))}
      {runtime.lookupFailed ? <p role="alert">{t("lookupFailed")}</p> : null}
      {runtime.terminal ? (
        <div className="space-y-2">
          <p>{t(runtime.terminal === "Completed" ? "recovered" : "failed")}</p>
          <Button variant="outline" onClick={runtime.dismiss}>
            {t("dismiss")}
          </Button>
        </div>
      ) : null}
    </aside>
  );
}
